import { Suspense, useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import Navbar, { NavbarSpacer } from "./Navbar";
import Footer from "./Footer";
import BecomePopup from "./BecomePopup";

const ScrollToTop = () => {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) {
      const el = document.getElementById(hash.slice(1));
      if (el) {
        el.scrollIntoView();
        return;
      }
    }
    window.scrollTo(0, 0);
  }, [pathname, hash]);
  return null;
};

const Layout = () => (
  <div className="min-h-screen bg-background text-foreground">
    <a
      href="#main-content"
      className="sr-only z-[100] rounded-sm bg-foreground px-4 py-2 text-background focus:not-sr-only focus:fixed focus:left-4 focus:top-4"
    >
      Skip to main content
    </a>
    <ScrollToTop />
    <Navbar />
    <NavbarSpacer />
    <main id="main-content">
      {/* Pages after the first load as separate chunks (src/App.tsx); keep the
          header and footer up while one arrives. */}
      <Suspense fallback={<div className="min-h-screen" />}>
        <Outlet />
      </Suspense>
    </main>
    <BecomePopup />
    <Footer />
  </div>
);

export default Layout;
